module.exports = __webpack_public_path__ + "static/media/hands_01.7a383045.svg";